import { render, staticRenderFns } from "./quote.vue?vue&type=template&id=947c5ce6&scoped=true&"
import script from "./quote.vue?vue&type=script&lang=ts&"
export * from "./quote.vue?vue&type=script&lang=ts&"
import style0 from "./quote.vue?vue&type=style&index=0&id=947c5ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947c5ce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
